export class LaborDetail {
  workTask: any;
  workDescription: string;
  chargeType: string;
  totalCosts: any;
}
